'use client';

import React from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { ServiceCardsSection } from '@/features/client/ServiceCardsSection/ServiceCardsSection';
import { ContentLayout } from '@/features/client/Services/components/ContentLayout/ContentLayout';
import { RequestForm } from '@/features/client/Forms/RequestForm/RequestForm';
import { ServicesNavMenu } from '@/features/client/Services/components/ServicesNavMenu/ServicesNavMenu';
import image from '@/public/images/services/main_page/air_conditiong.webp';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContentV2 } from '@/features/client/Services/components/Content/ContentV2';

import certified from '@/public/images/services/heating/certified.png';
import garanty from '@/public/images/services/heating/garanty.png';
import heating from '@/public/images/services/heating/heating.png';
import local from '@/public/images/services/heating/local.png';
import pricing from '@/public/images/services/heating/pricing.png';
import service from '@/public/images/services/heating/service.png';

const data = {
  title: 'Heating Services',
  description:
    'We specialize in <a href="https://tytum.com/services/heating-and-air/heating-installation">heating system installation</a>, repair and maintenance, ensuring your home or business remains warm and inviting. Enjoy the peace of mind that comes with a well-maintained and efficiently running heating system.',
  image: image,
  offer_title: '',
  offer_data: [
    {
      title: 'Heating Repair:',
      description:
        "If you're dealing with uneven warmth, strange odors, rising energy bills, or unexpected breakdowns, your system may require attention. Our team specializes in residential heating repair in San Diego, addressing issues like faulty wiring, thermostat malfunctions, and ductwork problems. Trust us for reliable heating repair in San Diego to restore comfort and functionality to your home.",
      list: [],
    },

    {
      title: 'Heating Installation: ',
      description:
        'We offer professional installation of energy-efficient heating systems, including furnaces, heat pumps, ductless units, and advanced smart thermostats. Our team specializes in expert <a href="https://tytum.com/services/heating-and-air/heating-installation">furnace installation in San Diego</a>, delivering dependable warmth and long-term efficiency for your home or business. We tailor every installation to meet your specific needs, with options like zoning systems, hydronic heating, and air filtration.',
      list: [
        { title: 'New furnace', description: '' },
        { title: 'Heat pump ', description: '' },
        { title: 'Ductless heating system ', description: '' },
        { title: 'Smart thermostat ', description: '' },
        { title: 'Zoning system ', description: '' },

        { title: 'Hydronic heating ', description: '' },
        { title: 'Boiler', description: '' },
        { title: 'Programmable thermostat ', description: '' },
        { title: 'Air filtration system ', description: '' },
        { title: 'Whole-house humidifier ', description: '' },
      ],
    },
    {
      title: 'Heating Replacement: ',
      description:
        'If your system is more than 15 years old, experiences constant breakdowns, or requires costly repairs, it might be a good time to consider replacing it. Older systems typically fall short in terms of energy efficiency when compared to newer models and can lead to increased energy costs and unexpected failures. Upgrade to a more reliable, cost-effective system today. Our experts provide heat repair and replacement services in San Diego customized to meet your unique requirements.',
      list: [],
    },
    {
      title: 'Heating Maintenance: ',
      description:
        'Routine maintenance is essential for making sure your system stays in peak operating condition. Issues like dirty filters, neglected ducts, and missed tune-ups can lead to uneven heating, short cycling, and unnecessary wear. Book routine <a href="https://tytum.com/services/heating-and-air/heating-maintenance">heating maintenance services in San Diego</a> to keep your system operating effectively and prevent expensive repairs.',
      list: [],
    },
  ],
  banner_title: `“Warmth When You Need It Most”`,
  banner_description:
    'Tytum’s heating services keep your home cozy and warm. We provide expert repair, maintenance, and installation to ensure reliable comfort throughout the winter.',
  bookServiceButton: true,
  why_title: '',
  why_description: '',
  why_items: [],
  why_footerText: '',
  extraContent: [
    {
      title: 'Why Choose Tytum for Heating Services?',
      description: '',
      image: null,
      items: [
        {
          title: 'Same-Day Service',
          image: service,
          description:
            "Heating issues can't wait. We provide fast, same-day heating repair services in San Diego to restore your system to optimal performance.",
        },
        {
          title: 'Certified Technicians',
          image: certified,
          description:
            'Our professionals provide proven experience and reliable service to each job, guaranteeing quality repairs, installations, and maintenance.',
        },
        {
          title: 'Transparent Pricing',
          image: pricing,
          description:
            'We offer straightforward pricing, ensuring you know the cost from the start with no unforeseen costs or unexpected charges.',
        },
        {
          title: 'Satisfaction Guaranteed',
          image: garanty,
          description:
            "We are committed to delivering exceptional quality in everything we do. Should you feel unsatisfied, we'll do everything we can to resolve it.",
        },
        {
          title: 'Comprehensive Heating Solutions',
          image: heating,
          description:
            'From heater repair in San Diego to full system installations, we take care of all your heating requirements with accuracy and attention to detail.',
        },
        {
          title: 'Local Expertise',
          image: local,
          description:
            'With a reputation for reliable heating services in San Diego, we offer personalized approaches for our community.',
        },
      ],
      footerText: '',
    },
    {
      title: 'Signs You Need Professional Heating Services',
      description: '',
      image: null,
      items: [
        {
          title: 'Inconsistent Heating',
          image: null,
          description:
            'If your home isn’t staying warm, mechanical failure or dirty filters might be the cause. Professional troubleshooting can detect and fix the problem.',
        },
        {
          title: 'Uneven Temperatures',
          image: null,
          description:
            'Cold spots or areas that are too hot may suggest issues with the ductwork or an imbalanced HVAC system.',
        },
        {
          title: 'Unusual Smells',
          image: null,
          description:
            'Burning, moldy, or chemical odors might signal electrical issues, dirt buildup, or gas leaks.',
        },
        {
          title: 'Rising Energy Bills',
          image: null,
          description:
            'Rising heating costs could indicate that your system is operating inefficiently and struggling to meet your needs.',
        },
        {
          title: 'Frequent Breakdowns',
          image: null,
          description:
            'Frequent system failures mean it’s time to call for expert residential heating repair in San Diego.',
        },
        {
          title: 'Strange Noises',
          image: null,
          description:
            'Noises like rattling, banging, or whistling typically indicate issues such as loose components, restricted airflow, or problems with the motor.',
        },
      ],
      footerText: '',
    },
    {
      title: 'How Do We Work?',
      description:
        'We simplify the process, ensuring a smooth and hassle-free experience for our clients. Here’s how it works:',
      image: null,
      items: [
        {
          title: '1. Contact Us',
          image: null,
          description:
            'Feel free to contact us or complete our online form to book your heating service appointment today.',
        },
        {
          title: '2. Schedule a Technician',
          image: null,
          description:
            'One of our skilled technicians will arrive promptly to inspect your system and suggest the best course of action.',
        },
        {
          title: '3. Receive a Solution',
          image: null,
          description:
            "Once we've identified the issue, we'll walk you through the problem and suggest the best repair solution or replacement options.",
        },
        {
          title: '4. Expert Service Delivery',
          image: null,
          description:
            'Our technicians will complete the work with care, ensuring your system operates as it should.',
        },
        {
          title: '5. Follow-Up Support',
          image: null,
          description:
            'Our technicians will complete the work with care, ensuring your system operates as it should.',
        },
      ],
      footerText:
        'Count on Tytum for expert heating service and repair in San Diego. Contact us today or get a free quote through our online form!',
    },

    {
      title: 'Frequently Asked Questions (FAQ)',
      description: '',
      image: null,
      items: [
        {
          title:
            '✓ How frequently should heating maintenance services in San Diego be scheduled?',
          image: null,
          description: (
            <>
              We suggest scheduling annual maintenance to maintain top
              performance and address any potential challenges, stopping them
              from evolving into serious issues.{' '}
              <a href="https://tytum.com/company/contact">
                Book your appointment today
              </a>{' '}
              to ensure your system stays in optimal condition!
            </>
          ),
        },
        {
          title: '✓ What does heating repair in San Diego typically cost?',
          image: null,
          description:
            'Heating repairs usually range from $150 to $500, depending on the issue. Contact us for a personalized estimate!',
        },
        {
          title: '✓ How fast can you respond to heating service calls?',
          image: null,
          description: (
            <>
              We provide same-day service for most heating services and repairs
              in San Diego, ensuring quick solutions when you need them most.{' '}
              <a href="https://tytum.com/company/contact">Call us today</a> for
              fast assistance!
            </>
          ),
        },
        {
          title:
            '✓ What are the signs that indicate I might need heating repair?',
          image: null,
          description:
            ' Be aware of signs such as inconsistent heating, unusual smells, increased energy costs, or frequent breakdowns. If you observe any of these issues, schedule a heat repair in San Diego without delay.',
        },
        {
          title: ' ✓ Can a smart thermostat help save energy?',
          image: null,
          description:
            'Yes! Smart thermostats help lower energy usage while improving overall comfort. Connect with us to explore how we can help you set one up in your home.',
        },
      ],
      footerText: (
        <>
          Count on Tytum for{' '}
          <a href="https://tytum.com/services/heating-and-air/heating-installation">
            expert heating service and repair in San Diego.
          </a>{' '}
          Get in touch with us today or submit a free quote request!
        </>
      ),
    },
  ],
};

const HeatingPage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="arrows">
        <MainSection
          label="Service Details"
          title="Heating & Furnace Repair Services in&nbsp;San&nbsp;Diego"
          description="Enjoy year-round warmth and comfort with expert heating repair service in San Diego. Whether it's repairs, maintenance, or system upgrades, we guarantee that your heating system will operate efficiently and effectively all year round."
          withContactButton
        />
      </MainSectionLayout>

      <Section variant="secondary">
        <Container>
          <ContentLayout
            contentLeft={
              <>
                <ServicesNavMenu />
                <RequestForm />
              </>
            }
            contentRight={
              <div>
                <ContentV2 data={data} />
                {/* <StaticSection style={{ marginTop: '6rem' }}>
                  <h2 className="mb-6 text-left text-4xl font-semibold">
                    Why Choose Tytum for Heating Services?
                  </h2>

                  <h3 className="mb-2 text-2xl">Same-Day Service</h3>

                  <p className="mb-6">
                    Heating issues can&apos;t wait. We provide fast, same-day{' '}
                    heating repair services in San Diego to restore your system
                    to optimal performance.
                  </p>

                  <h3 className="mb-2 text-2xl">Certified Technicians</h3>

                  <p className="mb-6">
                    Our professionals provide proven experience and reliable
                    service to each job, guaranteeing quality repairs,
                    installations, and maintenance.
                  </p>

                  <h3 className="mb-2 text-2xl">Transparent Pricing</h3>

                  <p className="mb-6">
                    We offer straightforward pricing, ensuring you know the cost
                    from the start with no unforeseen costs or unexpected
                    charges.
                  </p>

                  <h3 className="mb-2 text-2xl">Satisfaction Guaranteed</h3>

                  <p className="mb-6">
                    We are committed to delivering exceptional quality in
                    everything we do. Should you feel unsatisfied, we&apos;ll do
                    everything we can to resolve it.
                  </p>

                  <h3 className="mb-2 text-2xl">
                    Comprehensive Heating Solutions
                  </h3>

                  <p className="mb-6">
                    From heater repair in San Diego to full system
                    installations, we take care of all your heating requirements
                    with accuracy and attention to detail.
                  </p>

                  <h3 className="mb-2 text-2xl">Local Expertise</h3>

                  <p className="mb-6">
                    With a reputation for reliable heating services in San
                    Diego, we offer personalized approaches for our community.
                  </p>
                </StaticSection>

                <StaticSection>
                  <h2 className="mb-6 text-left text-4xl font-semibold">
                    Signs You Need Professional Heating Services
                  </h2>

                  <h3 className="mb-2 text-2xl">Inconsistent Heating</h3>

                  <p className="mb-6">
                    If your home isn’t staying warm, mechanical failure or dirty
                    filters might be the cause. Professional troubleshooting can
                    detect and fix the problem.
                  </p>

                  <h3 className="mb-2 text-2xl">Uneven Temperatures</h3>

                  <p className="mb-6">
                    Cold spots or areas that are too hot may suggest issues with
                    the ductwork or an imbalanced HVAC system.
                  </p>

                  <h3 className="mb-2 text-2xl">Unusual Smells</h3>

                  <p className="mb-6">
                    Burning, moldy, or chemical odors might signal electrical
                    issues, dirt buildup, or gas leaks.
                  </p>

                  <h3 className="mb-2 text-2xl">Rising Energy Bills</h3>

                  <p className="mb-6">
                    Rising heating costs could indicate that your system is
                    operating inefficiently and struggling to meet your needs.
                  </p>

                  <h3 className="mb-2 text-2xl">Frequent Breakdowns</h3>

                  <p className="mb-6">
                    Frequent system failures mean it’s time to call for expert
                    residential heating repair in San Diego.
                  </p>

                  <h3 className="mb-2 text-2xl">Strange Noises</h3>

                  <p className="mb-6">
                    Noises like rattling, banging, or whistling typically
                    indicate issues such as loose components, restricted
                    airflow, or problems with the motor.
                  </p>
                </StaticSection>

                <StaticSection>
                  <h2 className="mb-6 text-left text-4xl font-semibold">
                    How Do We Work?
                  </h2>

                  <p className="mb-4">
                    We simplify the process, ensuring a smooth and hassle-free
                    experience for our clients. Here’s how it works:
                  </p>

                  <h3 className="mb-2 text-2xl">1. Contact Us</h3>

                  <p className="mb-6">
                    Feel free to contact us or complete our online form to book
                    your heating service appointment today.
                  </p>

                  <h3 className="mb-2 text-2xl">2. Schedule a Technician</h3>

                  <p className="mb-6">
                    One of our skilled technicians will arrive promptly to
                    inspect your system and suggest the best course of action.
                  </p>

                  <h3 className="mb-2 text-2xl">3. Receive a Solution</h3>

                  <p className="mb-6">
                    Once we&apos;ve identified the issue, we&apos;ll walk you
                    through the problem and suggest the best repair solution or
                    replacement options.
                  </p>
                  <h3 className="mb-2 text-2xl">4. Expert Service Delivery</h3>

                  <p className="mb-6">
                    Our technicians will complete the work with care, ensuring
                    your system operates as it should.
                  </p>
                  <h3 className="mb-2 text-2xl">5. Follow-Up Support</h3>

                  <p className="mb-6">
                    Even after the job is done, we’re available for any
                    questions or further assistance you may need.
                  </p>

                  <p>
                    Count on Tytum for expert heating service and repair in San
                    Diego. Contact us today or get a free quote through our
                    online form!
                  </p>
                </StaticSection>

                <StaticSection>
                  <h2 className="mb-6 text-left text-4xl font-semibold">
                    Frequently Asked Questions (FAQ)
                  </h2>

                  <h3 className="mb-4 text-2xl">
                    ✓ How frequently should heating maintenance services in San
                    Diego be scheduled?
                  </h3>

                  <p className="mb-6">
                    We suggest scheduling annual maintenance to maintain top
                    performance and address any potential challenges, stopping
                    them from evolving into serious issues.{' '}
                    <a href="https://tytum.com/company/contact">
                      Book your appointment today
                    </a>{' '}
                    to ensure your system stays in optimal condition!
                  </p>

                  <h3 className="mb-4 text-2xl">
                    ✓ What does heating repair in San Diego typically cost?
                  </h3>

                  <p className="mb-6">
                    Heating repairs usually range from $150 to $500, depending
                    on the issue. Contact us for a personalized estimate!
                  </p>

                  <h3 className="mb-4 text-2xl">
                    ✓ How fast can you respond to heating service calls?
                  </h3>

                  <p className="mb-6">
                    We provide same-day service for most heating services and
                    repairs in San Diego, ensuring quick solutions when you need
                    them most.{' '}
                    <a href="https://tytum.com/company/contact">
                      Call us today
                    </a>{' '}
                    for fast assistance!
                  </p>
                  <h3 className="mb-4 text-2xl">
                    ✓ What are the signs that indicate I might need heating
                    repair?
                  </h3>

                  <p className="mb-6">
                    Be aware of signs such as inconsistent heating, unusual
                    smells, increased energy costs, or frequent breakdowns. If
                    you observe any of these issues, schedule a heat repair in
                    San Diego without delay.
                  </p>
                  <h3 className="mb-4 text-2xl">
                    ✓ Can a smart thermostat help save energy?
                  </h3>

                  <p className="mb-6">
                    Yes! Smart thermostats help lower energy usage while
                    improving overall comfort. Connect with us to explore how we
                    can help you set one up in your home.
                  </p>

                  <p>
                    Count on Tytum for{' '}
                    <a href="https://tytum.com/services/heating-and-air/heating-installation">
                      expert heating service and repair in San Diego.
                    </a>{' '}
                    Get in touch with us today or submit a free quote request!
                  </p>
                </StaticSection> */}
              </div>
            }
          />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ServiceCardsSection shortVariant={true} />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default HeatingPage;

/* const StaticSection = styled.div`
  text-align: left;
  margin-bottom: 6rem;

  a {
    text-decoration: underline;
  }
`;
 */
